import { render, staticRenderFns } from "./GlobalRisk.vue?vue&type=template&id=791d6eaf&"
import script from "./GlobalRisk.vue?vue&type=script&lang=js&"
export * from "./GlobalRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports